import classNames from 'classnames';

type SimpleLazyImageProps = {
  w: number | undefined;
  className: string | undefined;
  url: string;
  alt: string | undefined;
  onLoad?: () => void;
};

export function SimpleLazyImage({ w, className, url, alt, onLoad }: SimpleLazyImageProps) {
  return (
    <img
      width={w}
      className={classNames(className, 'w-full h-full object-cover')}
      src={url === '' ? undefined : url}
      alt={alt ?? ''}
      loading="lazy"
      onLoad={onLoad ? () => onLoad() : undefined}
    />
  );
}
